export default "__VITE_ASSET__BxnVpDkc__"